var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperK(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 65,
    viewBox: "0 0 36 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8903 0.766602L31.9346 3.46175L32.9453 4.57014L35.901 1.87499L34.8903 0.766602ZM1.5 1.02596H0V5.02596H1.5V1.02596ZM0 11.026H1.5V15.026H0V11.026ZM1.5 21.026H0V25.026H1.5V21.026ZM1.5 61.026H0V63.7359H1.5V61.026ZM1.5 31.026H0V35.026H1.5V31.026ZM0 51.026H1.5V55.026H0V51.026ZM0 41.026H1.5V45.026H0V41.026ZM5.33805 27.717L2.38281 30.4127L3.39369 31.5209L6.34892 28.8252L5.33805 27.717ZM24.5557 10.2014L27.5114 7.50622L28.522 8.61461L25.5663 11.3098L24.5557 10.2014ZM19.4562 47.9518L18.4453 49.06L21.4005 51.7557L22.4114 50.6475L19.4562 47.9518ZM25.8271 55.7863L26.8378 54.6779L29.7935 57.3731L28.7829 58.4815L25.8271 55.7863ZM4.67553 34.4683L3.66504 35.5769L6.62121 38.2715L7.6317 37.1629L4.67553 34.4683ZM33.2324 62.5227L34.2431 61.4143L35.9057 62.9303L34.895 64.0387L33.2324 62.5227ZM9.77539 23.681L12.7316 20.9864L13.7421 22.0949L10.7859 24.7895L9.77539 23.681ZM20.1217 14.2458L17.166 16.941L18.1767 18.0494L21.1324 15.3542L20.1217 14.2458ZM11.0547 42.3217L12.0654 41.2133L15.0211 43.9085L14.0104 45.0169L11.0547 42.3217Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperK);
export default __webpack_public_path__ + "static/media/UPPER_K.23a86f10bcbde7896a4b57d9647a7071.svg";
export { ForwardRef as ReactComponent };